import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


export default new Vuex.Store({
	state: {
		userInfo: {},
		hospId: '',
		hospName: '',
		hospIndex: ''
	},
	mutations: {
		getUserInfo (state, param) {
			state.userInfo = param
		},
		changeHosp (state,param) {
			state.hospId = param.hospId
			state.hospName = param.hospName
			state.hospIndex = param.hospIndex
		},
	}
})


// WEBPACK FOOTER //
// ./src/store/index.js